import styled, { keyframes, css } from "styled-components"; // <--- Importar CSS aqui

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const Container = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 550px;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: ${fadeIn} 0.3s ease-out;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
`;

export const Header = styled.div`
  background: #111827;
  padding: 20px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;

  .title-group {
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
      color: #d4af37;
      font-size: 20px;
    }

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
  }

  button {
    background: transparent;
    border: none;
    color: #9ca3af;
    font-size: 20px;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #fff;
    }
  }
`;

export const Body = styled.div`
  padding: 25px;
  overflow-y: auto;
  flex: 1;
`;

export const InfoSection = styled.div`
  margin-bottom: 25px;

  .top-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .contract-id {
    label {
      font-size: 12px;
      color: #6b7280;
      text-transform: uppercase;
      font-weight: 600;
    }
    h1 {
      margin: 0;
      font-size: 28px;
      color: #111827;
      font-weight: 800;
    }
  }
`;

export const Badge = styled.span`
  background: ${(props) =>
    props.type === "monthly"
      ? "rgba(16, 185, 129, 0.1)"
      : "rgba(212, 175, 55, 0.1)"};
  color: ${(props) => (props.type === "monthly" ? "#059669" : "#b48a1e")};
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const StatusBadge = styled.span`
  background: ${(props) => props.color}20;
  color: ${(props) => props.color};
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 800;
`;

export const GridFinanceiro = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 25px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const CardValue = styled.div`
  background: ${(props) => (props.highlight ? "#ecfdf5" : "#f9fafb")};
  border: 1px solid ${(props) => (props.highlight ? "#a7f3d0" : "#e5e7eb")};
  padding: 15px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .icon-box {
    width: 32px;
    height: 32px;
    background: ${(props) => (props.highlight ? "#10b981" : "#D4AF37")};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
  }

  label {
    font-size: 11px;
    color: #6b7280;
    font-weight: 600;
    display: block;
    margin-bottom: 2px;
  }

  h3 {
    margin: 0;
    font-size: 18px;
    color: #111827;
    font-weight: 700;
  }
`;

export const DetailList = styled.div`
  background: #fff;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 25px;
`;

export const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  &:first-child {
    padding-top: 0;
  }

  span {
    color: #6b7280;
    font-size: 13px;
  }
  strong {
    color: #374151;
    font-size: 13px;
  }
`;

export const SectionTitle = styled.h4`
  font-size: 14px;
  color: #374151;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;

  svg {
    color: #9ca3af;
  }
`;

export const DatesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .empty-msg {
    font-size: 13px;
    color: #9ca3af;
    font-style: italic;
  }
`;

export const DateChip = styled.div`
  background: #f3f4f6;
  color: #4b5563;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;

  /* LÓGICA DE CORES */
  ${(props) =>
    props.status === "passed" &&
    css`
      background: #fee2e2;
      color: #991b1b;
      border-color: #fecaca;
      text-decoration: line-through; /* Opcional: riscar datas passadas */
    `}

  ${(props) =>
    props.status === "active" &&
    css`
      background: #dcfce7;
      color: #15803d;
      border-color: #86efac;
      box-shadow: 0 0 5px rgba(22, 163, 74, 0.3);
    `}
`;

export const Footer = styled.div`
  padding: 20px 25px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  background: #f9fafb;

  button {
    background: #e5e7eb;
    color: #374151;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 700;
    cursor: pointer;
    font-size: 13px;
    transition: background 0.2s;

    &:hover {
      background: #d1d5db;
    }
  }
`;
